import * as types from '../actionTypes/ChallengesActionTypes';

export default function ChallengesReducer(
    state = {
        challenges: [],
        showLoader: false,
        error: null,
        acceptedChallengeId: null,
        acceptError: null,
    },
    action = {}
) {
    switch (action.type) {
        case types.GET_CHALLENGES: {
            return { ...state, showLoader: true, error: null };
        }

        case types.GET_CHALLENGES_SUCCESS: {
            return { ...state, challenges: action.challenges, showLoader: false };
        }

        case types.GET_CHALLENGES_ERROR: {
            return { ...state, error: action.error, showLoader: false };
        }

        case types.ACCEPT_CHALLENGE: {
            return { ...state, acceptedOfferId: null, acceptError: null, showLoader: true };
        }

        case types.ACCEPT_CHALLENGE_SUCCESS: {
            return { ...state, acceptedOfferId: action.offerId, showLoader: false };
        }

        case types.ACCEPT_CHALLENGE_ERROR: {
            return { ...state, acceptError: action.error, showLoader: false };
        }

        default:
            return state;
    }
}

ChallengesReducer.reducerName = 'challengesDetails';
